import {
	EDocSubscriptionEmailDto,
	OrderByEnum,
	ProductRequestDto,
	RequestParams,
	restRepository,
} from "@onair/repositories";

export interface GetTopProductsInput {
	limit?: string;
}

export interface EDocumentQueryParams {
	filter?: string;
	cursor?: string;
	order?: OrderByEnum;
	orderField?: string;
	offset?: number;
	limit?: number;
}
export const getEDocuments = async (data?: {
	query?: EDocumentQueryParams;
	params?: RequestParams;
}) => {
	try {
		const response = await restRepository.api.getEdocs(
			data?.query,
			data?.params,
		);
		return response.data;
	} catch (err) {
		console.log(err);
	}
};

export const createEdocSubscriptionEmail = async (
	payload: EDocSubscriptionEmailDto,
	params?: RequestParams,
) => {
	const response = await restRepository.api.createEdocSubscriptionEmail(
		payload,
		params,
	);
	return response.data;
};
